import React from 'react'
import PropTypes from 'prop-types'
import { Link } from '../Link/Link'
import { t, Trans } from '@local/translations'

export const OrderingNotAvailableBanner = ({ menuLink }) => {
  return (
    <p>
      <Trans
        i18nKey='ordering-not-available-banner.items-cannot-be-added'
        context={menuLink ? 'link' : undefined}
        components={{
          br: <br />,
          MenuLink: (
            <Link
              key='1'
              data-testid='link-to-menu-from-empty-cart-ordering-unavailable'
              to={menuLink}
              style='primary'
            />
          )
        }}
      />
    </p>
  )
}

OrderingNotAvailableBanner.propTypes = {
  menuLink: PropTypes.string
}
